import React from 'react'
import { LinkStyled, TextLink, TextButton, ButtonStyled, MenuStyled } from './styles'
import { MenuItem } from '@mui/material'
import { theme } from 'styles/theme/hav-theme'
import { Icon } from 'components'

type OptionDownloadLink = {
  label: string
  url: string
}

export interface DownloadLinkProps {
  href?: string
  content?: string
  target?: React.HTMLAttributeAnchorTarget
  options?: OptionDownloadLink[]
  disabled?: boolean
}

export const DownloadLink: React.FC<DownloadLinkProps> = ({
  href = '#',
  content = '',
  target = '_blank',
  options = [] as OptionDownloadLink[],
  disabled = false
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const containerRef = React.useRef<HTMLDivElement>(null)
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const selectModel = (url: string) => {
    window.open(url)
    setAnchorEl(null)
  }

  return (
    <>
      {options.length > 0 ? (
        <LinkStyled ref={containerRef}>
          <ButtonStyled
            id="basic-button"
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
            endIcon={
              <Icon icon="chevron-down" color={theme.colors.primary.main} size="15" />
            }
            disabled={disabled}
          >
            <TextButton disabled={disabled}>{content}</TextButton>
          </ButtonStyled>
          <MenuStyled
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={() => setAnchorEl(null)}
            MenuListProps={{
              'aria-labelledby': 'basic-button'
            }}
            minwidth={containerRef.current?.clientWidth}
          >
            {options.map((option) => (
              <MenuItem key={option.label} onClick={() => selectModel(option.url)}>
                {option.label}
              </MenuItem>
            ))}
          </MenuStyled>
        </LinkStyled>
      ) : (
        <LinkStyled>
          <Icon
            data-testid="download-icon"
            icon="download"
            color={theme.colors.primary.main}
            size="15"
          />
          <TextLink data-testid="download-link" target={target} href={href}>
            {content}
          </TextLink>
        </LinkStyled>
      )}
    </>
  )
}
